import type React from "react";
import { useEffect } from "react";
import SsoModals from "../molecules/SsoModals";

import type { JSX } from "react";
interface Props {
  title: string;
  children: JSX.Element;
}

const Page: React.FC<Props> = ({ title, children }) => {
  useEffect(() => {
    document.title = `${title} | North House`;
  }, [title]);

  return (
    <>
      {children}
      <SsoModals />
    </>
  );
};

export default Page;
